<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <search-dsp-select v-model="tableParams.dspId" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px;">
        <el-button @click="add" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{background:'#fafafa'}"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%">
          <el-table-column v-if="tableParams.isTime" sortable prop="timeHour" label="上报时间" align="center" />
          <el-table-column
            v-for="(v, i) in checkColumns"
            :prop="v.field"
            :label="v.title"
            :width="v.width"
            :min-width="v.minWidth"
            :key="i"
            align="center">
            <template v-slot="scope">
              <span v-if="v.field=='budgetNameIdList'">{{scope.row[v.field]?scope.row[v.field].map((item)=>{
                return item.budgetName}).join(","):"-"}}</span>
              <span v-else-if="v.field=='dspType'">{{scope.row[v.field]?getDspType[scope.row[v.field]-1]:'-'}}</span>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="100">
            <template v-slot="scope" align="center">
              <el-button @click="update(scope.row)" type="success" size="mini">编辑</el-button>
            </template>
          </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>

    <m-form @submit="toQuery" ref="form" title="DSP " />

  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import SearchDspSelect from '@/components/SearchDspSelect'
import mForm from './form'

import initTableMixin from '@/mixins/initTable'

export default {
  name: 'Manage/dsp',
  components: {
    TableColumn,
    mForm,
    SearchDspSelect
  },
  mixins: [initTableMixin],
  data () {
    return {
      columns: [
        { field: 'dspId', title: 'DSP编号' },
        { field: 'dspName', title: 'DSP简称' },
        { field: 'companyName', title: '公司名称' },
        { field: 'budgetNameIdList', title: '包含预算' },
        { field: 'dspThreshold', title: 'QPS阈值' },
        { field: 'ekey', title: '价格密钥' },
        { field: 'priceMacro', title: '价格宏' },
        { field: 'dspType', title: 'DSP类型' },
        { field: 'contactPerson', title: '联系人' },
        { field: 'contactPhone', title: '联系电话' },
        { field: 'contactEmail', title: '联系邮箱' },
        { field: 'createTime', title: '创建时间' }
      ],
      getDspType:["cpm","cpd","通用"]
    }
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/Dsp/getDsp'
      return true
    },
    add () {
      this.$refs.form.show()
    },
    update (row) {
      this.$refs.form.show(row)
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper{
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  &>*{
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child{
      margin-right: 0;
    }
  }

  &>.el-select,&>.el-input{
    width: 220px;
  }
}

.table-wrapper{
  padding: 15px;
  background: #ffffff;
  .table__operation{
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
